import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { registerEmailCode, registerUser, getRegisterEmailSubmitData } from "../../api/user/register-page";
import Loading from '../../components/loading';
import '../../stylesheets/user/register-email-submit.css';

export default function RegisterEmailSubmit() {
    const [pageData, setPageData] = useState({});
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(true);
    const inputRef = useRef(null);
    const registerFormData = JSON.parse(sessionStorage.getItem('registerFormData')) || {};
    const navigate = useNavigate();

    useEffect(() => {
        const loadingData = async () => {
            try {
                const res = await getRegisterEmailSubmitData();
                setPageData(res[0]);
                setLoading(false);
            } catch (error) {
                console.log(error);
            }
        };

        window.scrollTo(0, 0);
        loadingData();
    }, []);

    useEffect(() => {
        if (!loading && inputRef.current) {
            inputRef.current.focus();
        }
    }, [loading]);

    const onSubmit = async (event) => {
        event.preventDefault();

        try {
            setLoading(true);

            const res = await registerEmailCode(registerFormData.email, code);

            if (res.ok) {
                const resUser = await registerUser(registerFormData);

                if (resUser.ok) {
                    localStorage.setItem('reseller_customer_id', resUser.reseller_customer_id);
                    localStorage.setItem('token', resUser.token);
                    localStorage.setItem('user_id', resUser.user_id);

                    const SELECTED_HOSTING_PLAN_NAME = sessionStorage.getItem('SELECTED_HOSTING_PLAN_NAME');
                    const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');

                    if (SELECTED_HOSTING_PLAN_NAME) {
                        window.location.href = `/hosting/${SELECTED_HOSTING_PLAN_NAME}`;
                    } else if (redirectAfterLogin) {
                        window.location.href = redirectAfterLogin;
                    } else {
                        window.location.href = '/user';
                    }
                }
            }
        } catch (error) {
            console.log(error);
            alert(error.response.data.error)
            navigate("/user/register")
        } finally {
            sessionStorage.removeItem('redirectAfterLogin');
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="RegisterEmailSubmit wrapper">
            <h1>{pageData.title}</h1>
            <h2>{pageData.sub_title}</h2>

            <form onSubmit={onSubmit}>
                <label htmlFor="code">{pageData.input_label}</label>

                <input
                    ref={inputRef}
                    type="text"
                    id="code"
                    value={code}
                    onChange={e => setCode(e.target.value)}
                />

                <button type="submit" className="btn">{pageData.btn_text}</button>
            </form>

        </div>
    )
}
